import actions from '@/store/modules/billing/billing.action';
import mutations from '@/store/modules/billing/billing.mutation';
import getters from '@/store/modules/billing/billing.getter';
import datausage from '@/utils/templates/billing.usage.template';

export interface State {
  totalSizeList: Array<any>;
  activeAgentsListPerCapability: Array<any>;
  currentLicenseTab: any;
}

const initState: State = {
  totalSizeList: [],
  activeAgentsListPerCapability: [],
  currentLicenseTab: datausage?.navTabs?.[1]?.overviewTab?.[0]?.routerName
};

export default {
  namespaced: true,
  state: initState,
  getters: getters,
  actions: actions,
  mutations: mutations
};
